import {DomainMapper} from "@/core/config/domain-mapper";

export function getAlias() {
    const hostname = window.location.hostname;
    let alias = hostname.split(".")[0];

    // localhost, IP adresleri ve android test ortamı için default subdomain kullan
    const isLocalOrIP = hostname === 'localhost'
        || hostname === '10.0.2.2'
        || /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname);

    if (isLocalOrIP) {
        return process.env.VUE_APP_DEFAULT_SUBDOMAIN;
    }

    return DomainMapper[hostname] || alias;
}
